// localStorage "token" is the CSRF secret. Only a 200 from GET /api/profile/
// means the Django session is logged in. 401 and 403, including a missing
// CSRF token, leave the login page visible.

export function sessionFromProfileStatus(status) {
    if (status === 200) {
        return "authenticated";
    }
    return "anonymous";
}
